module.exports = __webpack_public_path__ + "fonts/bc7e330d/proxima_nova_bold-latin-a.eot";